import './load.css'

const Load = ({load}) => {

      if(load.length !== 0) return

      return (
            <div className="load_content">
                  <div className="load_circle"></div>
                  <div className="load_text">
                        <p>Wait Loading...</p>
                  </div>
            </div>
      )
}

export default Load
